export const blockIconsTextformattingAttachFileNew = (
	<span className='material-symbols-outlined'>attach_file</span>
);
